import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("veraso_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 401 → drop token and bounce to login
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401) {
      const onAuthRoute = /\/(login|register|auth\/callback)/.test(window.location.pathname);
      if (!onAuthRoute && localStorage.getItem("veraso_token")) {
        localStorage.removeItem("veraso_token");
        window.location.href = "/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);
